import { Button } from "@/components/ui/button/button";

type Props = {
	isValid: boolean;
	onUpdate: () => Promise<void>;
	settingTagButtonChildren?: React.ReactNode;
};

export const DesignMagazineHeaderRightChildren = ({ onUpdate, isValid, settingTagButtonChildren }: Props) => {
	return (
		<div className="flex w-full gap-x-3 laptop:w-auto laptop:gap-x-8">
			{settingTagButtonChildren}
			<Button
				size="xl"
				className="flex-1 whitespace-nowrap px-6 laptop:flex-none laptop:px-14"
				type="button"
				onClick={onUpdate}
				variant={isValid ? "default" : "disabled"}
			>
				保存
			</Button>
		</div>
	);
};

DesignMagazineHeaderRightChildren.displayName = "DesignMagazineHeaderRightChildren";
